export default __webpack_public_path__ + "static/image2-f9b8c403db73b49c5c9a2e0f6dd79553.webp";